<template>
  <!-- 数量弹窗 -->
  <div class="goodsNum">
    <van-popup v-model="xiugaiShow">
      <div class="box">
        <div class="lists">
          <span class="">修改购买数量</span>
        </div>
        <div class="storenum">可售库存{{ service.StoreNum }}</div>

        <van-stepper v-model="changeNum" />
        <div class="button-group">
          <div>
            <van-button plain class="cancel-button" type="primary" round @click="noChange">
              取消
            </van-button>
          </div>

          <div>
            <van-button class="submit-button" type="primary" round @click="() => changeSubmit(this.changeNum)">
              确定
            </van-button>
          </div>
        </div>
      </div>
    </van-popup>

    <div class="goodsNum">
      <div class="btnNum" @click="lessTap">-</div>
      <!-- <div class="num" @click="showChangeBox">{{ value }}</div> -->
      <input type="text" class="num" v-model="nums"  @input="changeInputNum($event)">
      <div class="btnNum" @click="addTap">+</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Stepper } from "vant";
import { Button } from "vant";

Vue.use(Button);
Vue.use(Stepper);

export default {
  props: {
    service: Object,
    value: Number,
  },
  data() {
    return {
      xiugaiShow: false,
      changeNum: 0,
      nums:0
    };
  },
  created(){
    this.nums = parseInt(this.value);
  },
  methods: {
    changeInputNum(e) {
      this.$emit("input", parseInt(this.nums)?parseInt(this.nums):1);
    },
    showChangeBox() {
      this.changeNum = this.value;
      this.xiugaiShow = true;
    },
    noChange(e) {
      this.xiugaiShow = false;
    },
    changeSubmit(changeNum) {
      this.xiugaiShow = false;
      this.$emit("input", changeNum);
    },

    addTap() {
      this.nums++;
      this.$emit("input", this.nums);
    },
    lessTap() {
      this.nums--;
      if (this.nums <= 0) {
        this.nums = 1;
      }
      this.$emit("input", this.nums);
    },
  },
};
</script>

<style lang="scss" lang="scss" scoped>
.box {
  width: 7rem;
  background: #fff;
  z-index: 11;
  text-align: center;
  font-size: 0.28rem;
  border-radius: 0.12rem;
  margin: auto;
  overflow: hidden;
  .tit {
    margin-bottom: 0.8rem;
  }
  .lists {
    padding: 0.2rem;
    box-sizing: border-box;
    font-size: 0.36rem;
    color: #1c1c1c;
    font-weight: bold;
    img {
      width: 0.3rem;
      height: 0.3rem;
    }
    .red {
      color: #e64340;
    }
    .grays {
      color: #888;
    }
  }
  .bobotm {
    border-bottom: 1px solid #f5f5f5;
  }
}
.goodsNum {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  // margin-top: 0.1rem;
  .btnNum {
    width: 0.4rem;
    height: 0.4rem;
    background: rgba(240, 240, 240, 1);
    box-shadow: 1px 0px 0px 0px rgba(230, 230, 230, 1);
    color: rgba(184, 184, 184, 1);
    text-align: center;
    line-height: 0.4rem;
    font-size: 0.3rem;
  }
  // div {
  //   &:nth-child(1) {
  //     border-radius: 0.4rem 0px 0px 0.4rem;
  //   }
  //   &:nth-child(3) {
  //     border-radius: 0 0.4rem 0.4rem 0;
  //   }
  // }
  .num {
    height: 0.4rem;
    width: 1rem;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(230, 230, 230, 1);
    font-size: 0.26rem;
    text-align: center;
    line-height: 0.4rem;
    color: #666;
    box-sizing: border-box;
  }
}

.button-group {
  display: flex;
  margin: 0.2rem;
  align-items: center;
  > div {
    flex: 1;
  }
  .submit-button {
    width: 2.5rem;
  }
  .cancel-button {
    width: 2.5rem;
  }
}
</style>
